import { SOCIAL_PLATFORMS } from '~/constants';
import { NAVIGATION_LINKS } from '~/screens/MediaPackDetailDefaultScreen/MediaPackDetailDefaultScreen.constants';

import { NavigationLink } from './ShareNavBar.model';

export const getConnectedLinks = (
  mediaPackPlatforms: SOCIAL_PLATFORMS[],
): NavigationLink[] => {
  const links = NAVIGATION_LINKS.reduce((acc, navigationLink) => {
    if (
      mediaPackPlatforms.includes(
        navigationLink.label.toLocaleLowerCase() as SOCIAL_PLATFORMS,
      )
    ) {
      acc.push(navigationLink);
    }

    return acc;
  }, [] as NavigationLink[]);

  return [NAVIGATION_LINKS[0], ...links];
};
